import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";

const myCustomTheme = {
  dark: false,
  colors: {
    primary: "#0c9f6b",
    secondary: "#FFEE58",
    theme: "#FFFFFF",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    background: "#efedf0",

    yellowColorVariant1: "#fac62a",
    yellowColorVariant2: "#fdedbf",
    yellowColorVariant3: "#c89e21",

    redColorVariant1: "#ff1919",
    redColorVariant2: "#FF5C5C",
    redColorVariant3: "#ba0f30",
    redColorVariant4: "#2e2b37",
    redColorVariant5: "#f2927a",

    greenColorVariant1: "#103137",
    greenColorVariant2: "#09c07b",

    blueColorVariant1: "#e5e8ed",
    blueColorVariant2: "#24156d",
    blueColorVariant3: "#004aad",
    blueColorVariant4: "#4a5e76",
    blueColorVariant5: "#017e65",
    blueColorVariant6: "#03fcca",
    blueColorVariant7: "#9bb8ed",

    greyColorVariant1: "#e5e5e5",
    greyColorVariant2: "#efefdo",
    greyColorVariant3: "#e3dddc",
    greyColorVariant4: "#f2f2f2",
    greyColorVariant5: "#e6e7e9",
    greyColorVariant6: "#ced9e4",

    blackVariant1: "#323232",
    blackVariant2: "#191919",
    blackVariant3: "#111c2d",
    blackVariant4: "#9fa4ab",
    blackVariant5: "#283242",
  },
};
export default createVuetify({
  defaults: {
    VSelect: {
      rounded: "lg",
      menuProps: { contentClass: "pharma-select-menu" },
    },
    VAutocomplete: {
      rounded: "lg",
      menuProps: { contentClass: "pharma-select-menu" },
    },
    VTextField: {
      rounded: "lg",
    },
    VTextarea: {
      rounded: "lg",
    },
    VBtn: {
      style: "text-transform: none; font-weight: 600; letter-spacing: 0.02em;",
    },
    VTab: {
      style: "text-transform: none; font-weight: 500;",
    },
  },
  theme: {
    defaultTheme: "myCustomTheme",
    themes: {
      myCustomTheme,
    },
  },
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
});
